import { useQuery } from '@tanstack/react-query';
import { AppLayout } from '.';

export default function ({ children, pageTitle = null }) {

    const sessionQuery = useQuery({
        queryKey: ['check-auth-session'],
        queryFn: async () => {
            const { data } = await axios.get(route('api.auth.check'));

            if(data?.logged_in == false){
                location.reload();
            }

            return data || [];

        },
        refetchInterval: 600000,
        refetchIntervalInBackground: true,
        refetchOnWindowFocus: true,
    });

    return (
        <AppLayout
            pageTitle={pageTitle}
            headerProps={{
                logoProps: {
                    type: 'crm',
                    link: {
                        href: '/'
                    }
                },
                menuItems: [

                ],
                profileUrl: '/profile',
                logoutUrl: 'logout',
            }}
            withFooter={false}>
            {children}
        </AppLayout>
    )
}